var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.667 22.6627H37.3336C37.3336 15.8227 32.1696 10.6641 25.3203 10.6641V13.3307C30.7363 13.3307 34.667 17.2547 34.667 22.6627Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3337 18.6696C28.1377 18.6696 29.3337 19.8656 29.3337 22.6696H32.0004C32.0004 18.3696 29.6337 16.0029 25.3337 16.0029V18.6696ZM29.8964 25.9269C29.6402 25.6941 29.3035 25.5699 28.9574 25.5806C28.6114 25.5913 28.283 25.736 28.0417 25.9843L24.851 29.2656C24.083 29.1189 22.539 28.6376 20.9497 27.0523C19.3604 25.4616 18.879 23.9136 18.7364 23.1509L22.015 19.9589C22.2636 19.7178 22.4086 19.3894 22.4193 19.0432C22.43 18.697 22.3056 18.3603 22.0724 18.1043L17.1457 12.6869C16.9124 12.4301 16.5882 12.2743 16.2419 12.2526C15.8956 12.2309 15.5545 12.3451 15.291 12.5709L12.3977 15.0523C12.1672 15.2836 12.0296 15.5915 12.011 15.9176C11.991 16.2509 11.6097 24.1469 17.7324 30.2723C23.0737 35.6123 29.7644 36.0029 31.607 36.0029C31.8764 36.0029 32.0417 35.9949 32.0857 35.9923C32.4117 35.974 32.7195 35.8358 32.9497 35.6043L35.4297 32.7096C35.6557 32.4463 35.7701 32.1053 35.7487 31.759C35.7273 31.4127 35.5717 31.0884 35.315 30.8549L29.8964 25.9269Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.4a90fcdd3b9e82e590415eb4e9c420b0.svg";
export { ForwardRef as ReactComponent };